/**
 * Route Configuration
 * Centralizes all route definitions and panel mappings.
 */

export const ROUTES = {
  LOGIN: '/login',
  SIGNUP: '/signup/:session_id',
  HOME: '/home',
  VESSELS: '/vessels',
  VESSEL_DETAILS: '/vessels/:id',
  FLEET_MANAGER: '/fleet-manager',
  SATELLITES: '/satellites',
  TASKING: '/tasking',
  DRONES: '/drones',
  RULES_ALERTS: '/rules-alerts',
  SENSOR_FUSION: '/sensor-fusion',
  SENSOR_FUSION_RESULTS: '/sensor-fusion/results',
  SENSOR_FUSION_DEMO: '/sensor-fusion/demo',
  GEOFENCES: '/geofences',
  SANCTIONS: '/sanctions',
  INCIDENTS: '/incidents',
  REPORTS: '/reports',
  INSIGHTS: '/insights',
  ACCOUNT: '/account',
  RULE_DETAILS: '/rules-alerts/:id',
  NETWORK: '/network',
  AREA_TRAFFIC: '/area-traffic',
  ILLEGAL_FISHING: '/illegal-fishing',
} as const;

export const ROUTE_CONFIG: Record<string, { panel: string }> = {
  [ROUTES.VESSELS]: { panel: 'Vessels' },
  [ROUTES.FLEET_MANAGER]: { panel: 'Fleet Manager' },
  [ROUTES.SATELLITES]: { panel: 'Satellites' },
  [ROUTES.TASKING]: { panel: 'Tasking Panel' },
  [ROUTES.DRONES]: { panel: 'Drones' },
  [ROUTES.RULES_ALERTS]: { panel: 'Rules and Alerts' },
  [ROUTES.SENSOR_FUSION]: { panel: 'Sensor Fusion' },
  [ROUTES.SENSOR_FUSION_RESULTS]: { panel: 'Sensor Fusion' },
  [ROUTES.SENSOR_FUSION_DEMO]: { panel: 'Sensor Fusion' },
  [ROUTES.GEOFENCES]: { panel: 'Geofences' },
  [ROUTES.SANCTIONS]: { panel: 'Sanctions' },
  [ROUTES.INCIDENTS]: { panel: 'Piracy Incidents' },
  [ROUTES.REPORTS]: { panel: 'Reports' },
  [ROUTES.INSIGHTS]: { panel: 'Insights' },
  [ROUTES.ACCOUNT]: { panel: 'Account' },
  [ROUTES.NETWORK]: { panel: 'Network' },
  [ROUTES.AREA_TRAFFIC]: { panel: 'Area Traffic' },
  [ROUTES.ILLEGAL_FISHING]: { panel: 'Illegal Fishing' },
};

export const getRouteForPanel = (panelName: string): string => {
  const entry = Object.entries(ROUTE_CONFIG).find(([_, config]) => config.panel === panelName);
  return entry ? entry[0] : ROUTES.HOME;
};
